import http from "../../http";

/** 共治统计 — /resident/api/resident/houseCoGovStat */
const BASE = "/resident/api/resident/houseCoGovStat";

export default {
  selectPage(r) {
    return http.get(`${BASE}/page`, r);
  },
  selectLive(r) {
    return http.get(`${BASE}/live`, r);
  },
  rebuild(r) {
    return http.payload(`${BASE}/rebuild`, r);
  },
};
